import axios from "axios";
import config from "@/config";

const API_URL = config.apiUrl + config.apiUrlPrefix;

class ToolsService {

    getAllSettings(data) {
        return axios({
            method: 'GET',
            url: `${API_URL}/settings`,
            params: data
        });
    }


    updateSettings(data) {
        return axios({
            method: 'POST',
            url: `${API_URL}/settings`,
            data: data
        });
    }


}

export default new ToolsService();